import { App } from 'vue'
import KoneTooltip from './kone-tooltip/index.vue'
import KoneIcon from './kone-icon/index.vue'

export const setupCustomComponent = (app: App) => {
  // 注册组件
  app.component('KoneTooltip', KoneTooltip)
  app.component('KoneIcon', KoneIcon)
  // app.component('KoneTooltip', () => import('./kone-tooltip/index.vue'))
}
